/*--------------------------------------------------------------------------------------------------
	Static
--------------------------------------------------------------------------------------------------*/

var Static = {
	version: 0,

	base: '',

	user: {},
	site: {},
	sock: false,

	tmp: {},
	channel: {categories: {}},

	radio: {
		list_id: '',
		updater: 0,
		hide_nl: false,
		stats: {}
	},

	playing: {
		id: 0,
		status: -1,
		type: '',

		list_id: '',
		list: [],

		list_shuffled: [],
		shuffle: (typeof s != 'undefined' && s != null ? s == 1 : false),

		path: '',

		duration: 0,
		position: 0,
		volume: (typeof v != 'undefined' && v != null ? v : 0.8),
		mode: 'flash'
	},

	selectedItem: 0,
	movingItem: 0,
	background: '',

	pjax: false,
	pjax_page: false,
	mobile: false,
	lightbox: false,
	hal: 1,
	server: window.location.hostname.indexOf('beta') != -1 ? 'https://beta.hlamer.ru/' : 'https://hlamer.ru/',

	search: { started: false, section: 'video', counter: -1, mode: ''},
	vector_search: { started: false, section: 'video', counter: -1 },

	init: function(version, site, user, module, pjax) {
		this.version = version;
		this.user = user;
		this.module = module;
		this.pjax = pjax;
		this.site = site;
		this.server = site.server;

		if (user.id > 0 && !this.sock) {
			var wsUrl = (window.location.protocol != 'https:' ? 'ws://w.' : 'wss://w.') + window.location.hostname.replace('beta.', '');
			this.sock = new MultiSocket(wsUrl, {action: 'subscribe', hash: Static.user.session});
			if (!this.sock.sock) return;

			this.sock.bind('counts', function(e) {
				user.balance = e.balance; $('#account').html(user.balance);

				setCounter('profile', e.fi);
				setCounter('fi', e.fi);

				setCounter('npm', e.npm);

				if(e.vc) $('#link_vc').show(); else $('#link_vc').hide();

				setCounter('video', e.vc);
				setCounter('vc', e.vc);

				setCounter('nl', e.nl);

				setCounter('news', e.nu + e.ncu);
				setCounter('nu', e.nu);
				setCounter('ncu', e.ncu);
			});

			this.sock.bind('counts_pm', function(data) {setCounter('nd', data, true);});
			this.sock.bind('video_Watched', video_Watched);
			this.sock.bind('pm', function(data) {
				if(Static.dialog && data.dialog_id == Static.dialog.id) {
					dialog_renderPost(data, Static.user.id == data.user_id ? Static.dialog.here : true);
					if(!Static.dialog.active && Static.user.id != data.user_id) {
						Static.dialog.count_new++;
						document.title = Static.dialog.u[2] + ' (' + Static.dialog.count_new + ')  |  Диалоги';
					}
				}
			});
			this.sock.bind('notify', function(data) {
				if(data.type == "dialog") dialog_renderNotify(data);
				else if(data.type == "thread") thread_renderNotify(data);
				else if(data.type == "vote") vote_renderNotify(data);
			});
		}
		if((user.id < 0 || !user.vip) && !cookie_get("user-hal")) {
			nbl.l("/resource/js/adframe.js", function() {Static.hal = 0;});
			setTimeout(function() {cookie_set('user-hal', Static.hal, 7200);}, 5000)
		}
	},

	subscribe: function(act, func) {
		//sock_listeners[act] = func
	},

	upd: function(version, user, module, data) {
		//if (this.version < version) document.location.reload();
		if(this.user > 0 && user == -1) locationReplace(window.location.href);
		this.user = user;
		this.pjax_page = true;
		$('#account').html(user.balance);

		if(this.module != module) {
			$('#module-'+this.module).removeClass('s');
			$('#module-'+module).addClass('s');
			this.module = module;
		}

		var body = $('body');
		body.css('background', data.background ? data.background : '').css('background-size', data.background ? '100% auto' : '');

		if (data.body_class) body.addClass(data.body_class); else body.removeClass();
		if (data.header_style) {
			$('#user-bar').addClass(data.header_style);
			$('#ads-top').addClass(data.header_style);
		} else {
			$('#user-bar').removeClass();
			$('#ads-top').removeClass();
		}
	},

	update: function(user_id, login, session, balance, module) {
		this.user.id = user_id;
		this.user.login = login;
		this.user.session = session;
		this.user.balance = balance;
		$('#account').html(balance);

		if (this.module != module) {
			$('#module-'+this.module).removeClass('s');
			$('#module-'+module).addClass('s');
		}
		this.module = module;
	},
	thread: {replying: 0}
};

function pjax_Init() {
	if (!$.support.pjax) return;
	if (typeof Static.pjax_init != 'undefined') return;
	Static.pjax_init = true;

	$(document).pjax('a:not(.highslide, .ext)', '#dynamic-content', {timeout: 2000});

	function page_cleanup() {
		if (Static.player) {
			Static.player.pause();
			Static.player.remove();
			Static.player = 0;
		}
		$('#video-container').hide();

		if (Static.dialog && Static.dialog.id) {
			Static.sock.send({action: 'unsubscribe_dialog', dialog_id: Static.dialog.id});
			Static.sock.unbind('here');
			Static.sock.unbind('history');
			Static.dialog.id = 0;
			Static.dialog = 0;
		}

		if ($('.imgareaselect-box').length) $('.imgareaselect-box').remove();
		if ($('.imgareaselect-outer').length) $('.imgareaselect-outer').remove();
		if ($('#dialog')) $.dialog_Hide(true);
		if ($('.select2-container').length) $('.select2-container').remove();
		if ($('.vget-video-highlight').length) $('.vget-video-highlight').remove();
		if ($('.select2-drop').length) $('.select2-drop').remove();
		if ($('.links-dropdown.dropdown-active').length) $('.links-dropdown').removeClass('dropdown-active');
	}

	$(document).on('pjax:beforeSend', page_cleanup);

	$(document).on('pjax:click', function(e) {
		if (Static.thread.id && Static.user.id > 0) {
			Static.sock.send({action: 'unsubscribe_thread'});
			Static.sock.unbind('post');
			clearInterval(Static.thread.period_update);
			Static.thread = {};
		}

		if (Static.search.started) Static.search.started = false;
		var href = e.target.href;
		if (href.indexOf('.jpg') > 0 || href.indexOf('.jpeg') > 0 || href.indexOf('.png') > 0) {e.preventDefault();}
		$(document).trigger('page.clean');
		page_cleanup();
		if (Static.video_context) {
			delete Static.video_context;
			Static.video_context = null;
		}
	});

	$(document).on('pjax:complete', function() {
		console.log("pjax:complete");
	});
	$(document).on('pjax:end', function() {
		//console.log("sending hit, this is a new url: " + window.location.href);
		if (window.ga) ga('send', 'pageview');
		if (typeof (yaCounter7709395) != 'undefined') {
			yaCounter7709395.hit(window.location.href);
		}
	});

	// fix back button (https://github.com/defunkt/jquery-pjax/issues/241)
	$(document).on('pjax:popstate', function() {
		$(document).one('pjax:end', function(event) {
			//page_cleanup();
			$('#video-container').show();
			$(event.target).find('script').each(function() {
				var exec = true;
				if (this.text.indexOf('Static.init') >= 0) exec = false;
				if (this.text.indexOf('main_Init') >= 0) exec = false;
				if (exec) {
					try {
						$.globalEval(this.text || this.textContent || this.innerHTML || '');
					} catch(e) {console.log(e);}
				}
			})
			event.preventDefault();
		});
	});
}

function local_auth(hash, no_redirect) {
	$.ajax({type: "POST", url: "/ajax/auth_set", data: {hash: hash}})
	.done(function(data2) {if(data2 != 'ok') crossdomain_iframe(domain, hash); else if(!no_redirect) redirect();})
	.fail(function(jqXHR, status) {alert(status);});
}

function crossdomain_auth(login) {
	if (Static.site.type == 'video') return;
	$.ajax({type: "POST", url: Static.server + "ajax/auth",
		xhrFields: {withCredentials: true},
		crossDomain: true,
		success: function(data) {
			if ((data == 'fail' || !data) && login) {
				window.location = Static.server + "login?redirect=" + window.location.href;
				return;
			}
			if (data && data.length > 5) local_auth(data);
			else cookie_set('no_auth', 1, 3600);
		}
	});
}

function redirect_after_auth(redirect) {
	if (typeof redirect == 'undefined') return 1;
	else if (redirect === '') window.location.reload();
	else if (redirect === 1) window.location.reload();
	else window.location = redirect;
}

function crossdomain_auth2(domains, hash, redirect) {
	var counter = domains.length;
	for (var i in domains) {
		if (domains[i] == window.location.hostname) {
			counter--;
			local_auth(hash, counter);
			continue;
		}
		var domain = window.location.protocol + '//' + domains[i] + '/';

		$.ajax({
			type: "POST", url: domain + "ajax/auth_set",
			data: { hash: hash },
			xhrFields: { withCredentials: true }, crossDomain: true,
			error: function () { crossdomain_iframe(domain, hash); }
		}).done(function (data) {
			if (data != 'ok') crossdomain_iframe(domain, hash);
			counter--;
			if (!counter && data == 'ok') redirect_after_auth(redirect);
		}).fail(function (jqXHR, status) { alert(status); });
	}

	if (typeof redirect != 'undefined') {
		setTimeout(function() {
			redirect_after_auth(redirect);
		}, 800);
	}
}

function crossdomain_iframe(domain, hash) {
	//console.log(domain + '?crossauth&hash=' + hash);
	//window.location = domain + '?crossauth&hash=' + hash;
	var ifrm = document.createElement("iframe");
	ifrm.setAttribute("src", domain + 'ajax/auth_set?hash=' + hash);
	ifrm.style.width = "1px";
	ifrm.style.height = "1px";
	document.body.appendChild(ifrm);
}

function crossdomain_auth_guest(domain, guest_id) {
	$.ajax({type: "POST", url: domain + "ajax/guest_set",
		data: {guest_id: guest_id},
		xhrFields: {withCredentials: true}, crossDomain: true
	});
}

/*--------------------------------------------------------------------------------------------------
	User
--------------------------------------------------------------------------------------------------*/

function user_showLoginForm() {
	crossdomain_auth(true);
	player_deFocus();
	if (Static.site.type != 'video') $.ajaxSetup({ crossDomain: true, xhrFields: { withCredentials: true } });
	var captcha = false;
	function captcha_init() {
		if (captcha) return;
		$("#dialog-content-top").append("<script src='https://www.hCaptcha.com/1/api.js' async defer></script><div class='h-captcha' data-sitekey='c897f5da-9c50-432e-a6e2-ab96472cf8f4'></div>");
		$('#dialog').data('extra', {'h-captcha-response':0});
		captcha = true;
	}
	$('#static-content').dialog({
		title: 'Вход',
		action: Static.server + 'user/?mode=ajax_login',
		fields: {
			'login': ['text','Логин',cookie_get('user_login')],
			'password': ['password','Пароль','']
		},
		text_after: "<a href='/login/recover'>Забыли пароль?</a>",
		buttons: {
			'enter': ['submit','Войти &rarr;']
		},
		ajax: true,
		onSuccess: function(data) {
			crossdomain_auth2(data.domains, data.hash, data.url ? undefined : 1);
			if (data.url) user_showTFA(data.url);
		},
		onError: function(data) {
			if(data.fail) captcha_init();
			if(typeof grecaptcha != 'undefined') grecaptcha.reset();
		}
	});
	$.get('/ajax/auth_fail', function (res) { if (res > 3) captcha_init(); });

	$('#dialog-content-sub').html("<div class='left dialog-oauth-icons oauth-icons'>" +
	"<a href='https://oauth.vk.com/authorize?scope=offline&client_id=2741886&redirect_uri=https://hlamer.ru/oauth/?server=1&response_type=code' title='Войти через Вконтакте'><img width=26 height=26 src='/resource/image/social_big/vk.svg'/></a>" +
	" <a href='https://connect.mail.ru/oauth/authorize?client_id=657924&redirect_uri=https://hlamer.ru/oauth/?server=4&response_type=code' title='mail.ru'><img src='/resource/image/social_big/mail_ru.png'/></a>" +
	" <a href='https://oauth.yandex.ru/authorize?client_id=f19b294e608f4f66b5d558ab82601878&response_type=code&redirect_uri=https://hlamer.ru/oauth/?server=6' title='Яндекс'><img src='/resource/image/social_big/yandex.svg'/></a>" +
	" <a href='/oauth/?server=5&code=1' title='kraslan.ru'><img src='/resource/image/social_big/kraslan.png'/></a>"
	+ "</div><div class='right'>" + $('#dialog-content-sub').html() + "</div>");

	user_onSocial();
	return false;
}

function user_showTFA(url) {
	$('#static-content').dialog({
		title: 'Двухфакторная аутентификация',
		action: '/user/?mode=ajax_check_tfa',
		fields: {
			'code': ['text','Код подтверждения'],
		},
		//text_after: "<center><img src='" + url + "'></center>",
		buttons: {
			'enter': ['submit','Войти &rarr;']
		},
		ajax: true,
		onSuccess: function(data) {
			//console.log(data);
			if (data.success) window.location.reload();
		},
		onError: function(data) {
			console.error(data);
		}
	});
}

function user_onSocial() {
	$('.oauth-icons a').click(function() {
		if (Static.site.type == 'video') cookie_set('redirect_to', window.location.href);
		else {
			$.ajax({type: "POST", url: Static.server + "ajax/auth_location_save",
				xhrFields: {withCredentials: true}, crossDomain: true,
			});
		}
	});
}

function uploadPhoto(section, id, allow_remove) {
	$('#photo-buttons').hide();
	$('#photo-container').hide().before("<div id='uploader' class='search' style='text-align: center;'>\
	<iframe id='iframe-photo-form' name='iframe-photo-form' src='javascript:false' style='width: 1px; height: 1px; display: none;' frameborder='0'>\
	</iframe>\
	<br><form id='photo-form' action='/ajax.php?mode=upload-photo&id=" + id + "&section=" + section + "' method='post'  enctype='multipart/form-data' target='iframe-photo-form'>\
	<input type='file' name='photo' onChange='$(this.form).submit();'><br><br><small>Если фотография больше 600 пикселей по высоте, то она будет уменьшена." + (allow_remove ? "<br><br><a href='#' onClick='return deletePhoto(\"" + section + "\", " + id + ");'>удалить фото</a>" : "") + "</small></form></div>");

	$('#iframe-photo-form').on('load', function() {
		var doc = this.contentDocument ? this.contentDocument : window.frames[this.id].document;

		if (doc.body) {
			var response = doc.body.innerHTML;

			response = /{(.*?)}/.exec(response);
			if (response && response[0]) response = response[0];

			try {
				var data = JSON.parse(response);

				if (data.error != null) {
					alert(data.error);
				} else {
					if (section == 'user') Static.sock.send({ action: 'user_change' });
					$('#uploader').remove();
					$('#photo-container').html("<div><a href='" + data.path + data.hash + "_original.jpg' class='highslide'><img src='" + data.path + data.hash + ".jpg' id='avatar'></a></div>").show();
					$('#photo-buttons').show();
					if ($('#user-avatar').length) $('#user-avatar').html("<img src='" + data.path + data.hash + "_48.jpg'>");
				}
			} catch (e) { }
		}
	});

	return false;
}

function deletePhoto(section, id) {
	$.get('/ajax.php?mode=delete-photo&id=' + id + '&section=' + section);

	if ($('#user-avatar').length) $('#user-avatar').html();
	$('#photo-container').html();
	$('#photo-buttons').show();
	$('#uploader').fadeOut('fast', function() { $(this).remove(); });

	return false;
}

function PhotoPreview(img, selection) {
	if (!selection.width || !selection.height) return;

	var scaleX = 48 / selection.width,
		scaleY = 48 / selection.height,
		img = $("#user-avatar > img"), avatar = $('#avatar');

	img.css({
		width: Math.round(scaleX * avatar[0].naturalWidth) + "px",
		height: Math.round(scaleY * avatar[0].naturalHeight) + "px",
		marginLeft: "-" + Math.round(scaleX * selection.x1) + "px",
		marginTop: "-" + Math.round(scaleY * selection.y1) + "px"
	});
	img.attr("x", selection.x1);
	img.attr("y", selection.y1);
	img.attr("w", selection.width);
	img.attr("h", selection.height);
}

function editPhotoPreview(type, id) {
	nbl.l(['/resource/js/jquery.imgareaselect.min.js', '/resource/imgareaselect-animated.css'], function() {editPhotoPreviewExec(type, id);});
}

function editPhotoPreviewExec(type, id) {
	var avatar = $('#avatar'), original = avatar.attr("src").replace('.jpg', '_original.jpg');
	if (type == 'channel' || type == 'set') $("#photo-container").after("<div id='user-avatar'><img src='" + original + "'></div>");
	$("#user-avatar > img").attr("src", original);
	$('#photo-buttons').hide();
	$('#photo-container').html("<div><img id='avatar' src='" + original + "' width='100%'></div><br><a href='#' onclick=\"editPhotoSave('" + type + "', '" + id + "')\">Сохранить изменения</a>");
	avatar = $('#avatar');

	avatar.attr("src", original).one('load', function() {
		var x2 = Math.min(this.naturalWidth, this.naturalHeight) - 2;
		avatar.imgAreaSelect({
			aspectRatio: "1:1",
			handles: true,
			imageWidth: this.naturalWidth,
			imageHeight: this.naturalHeight,
			x1: 0, y1: 0, x2: x2, y2: x2,
			onInit: PhotoPreview,
			onSelectEnd: PhotoPreview
		});
	});

	return false;
}

function editPhotoSave(type, id) {
	var img = $("#user-avatar > img"),
		x = img.attr("x"),
		y = img.attr("y"),
		w = img.attr("w"),
		h = img.attr("h");

	if (!w || !h) { alert("Сначала отметьте область выделения"); return false; }
	if (w < 3 || h < 3) { alert("Область выделения не должна быть точечной"); return false; }

	if (type == 'user') {
		$.post("/people/" + Static.user.id + "/?section=photo-preview", {x:x,y:y,w:w,h:h}, function() {redirect();});
	} else if (type == 'channel') {
		$.post("/channel/" + id + "/?section=ajax_photo_preview", {x:x,y:y,w:w,h:h}, function() {redirect();});
	} else if (type == 'set') {
		$.post("/set/" + id + "/?ajax=photo_preview", {x:x,y:y,w:w,h:h}, function() {redirect();});
	}

	return false;
}

function user_statusChange() {
	var status = $('#user-status'), tmp = status.html();

	var $f = $("<input type='text' id='status'>");
	$f.keyup(function(event) {
		if(event.keyCode == 13) this.blur();
	});

	$f.blur(function() {
		setTimeout(function() {
			if ($('#status').length) {
				var val = $('#status').val();
				if (val != '') {
					$.post('/people/' + Static.user.id + '?section=ajax_status_set', {status: val}, function(data) {
						status.html(data);
					});
				} else {
					status.html(tmp);
				}
			}
		}, 200);
	});

	status.html('').append($f).append("<br><small><a href='#' onClick=\"$('#status').val('').blur(); return false;\">отменить</a></small>").show();
	$f.focus();

	return false;
}

function user_statusDelete() {
	$('#user-status').on('load', $.get('/people/' + Static.user.id + '?section=ajax_status_delete', function() {$('#user-status').html("<a href='#' onClick='return user_statusChange();'>Изменить статус</a>");}));

	return false;
}


function user_statusHistory(uid) {
	if (!$('#user-status-etc').is(':visible') && uid != undefined) {
		$('#user-status-etc').html("<img src='/resource/image/icon/ajax.gif'>").show().on('load', '/people/' + uid + '?section=ajax_status_history');
	} else {
		$('#user-status-etc').hide();
	}
	return false;
}

//--------------------------------------------------------------------------------------------------

function user_addFriend(id) {
	$('#static-content').dialog({
		title: 'Добавить в друзья',
		fields: {
			'message': ['textarea','Сообщение (необязательно)', '']
		},
		buttons: {
			'save' : ['submit','Подружиться'],
			'cancel' : ['cancel','Отмена']
		},
		action: '/people/' + id + '/?section=ajax_friend' ,
		method: 'post',
		ajax: true,
		onSuccess: function(data) {redirect();}
	});

	return false;
}

function user_removeFriend(id) {
	if (!confirm('Удалить из друзей?')) return false;
	$.ajax('/people/' + id + '/?section=ajax_unfriend');
	if($('#user-' + id).length) $('#user-' + id).fadeOut('fast', function() {$(this).remove();});
	else redirect();
	return false;
}

function user_declineFriend(id) {
	$.ajax('/people/' + id + '/?section=ajax_unfriend');
	$('#user-' + id).fadeOut('fast', function() {$(this).remove();});
	return false;
}

function user_acceptFriend(id) {
	$.ajax('/people/' + id + '/?section=ajax_friend');
	$('#accepts-' + id).fadeOut('fast', function() {$(this).remove();});
	return false;
}

function user_addFoe(id) {
	if (!confirm('Уверены? Враг не сможет писать вам личные сообщения и на вашей стене.')) return false;
	$.get('/people/' + id + '/?section=ajax_foe', function(data) {
		if (data.success) redirect();
		else alert(data.error);
	}, 'json');
	return false;
}

function user_removeFoe(id) {
	$.ajax('/people/' + id + '/?section=ajax_unfoe').done(function() {
		if ($('#user-' + id).length) $('#user-' + id).fadeOut('fast', function () { $(this).remove(); });
		else redirect();
	});
	return false;
}

function user_ignoreVideo(id) {
	if (!confirm('Уверены, что хотите игнорировать видео этого пользователя?')) return false;
	$.get('/people/' + id + '/?section=ajax_ignore', function(data) {console.log(data);
		if (data.success == 1) alert("Вы больше не увидите видео от этого человека на главной");
		else if (data.success == 2) { if (confirm("Уже в игноре, хотите отменить?")) user_unignoreVideo(id); }
		else alert(data.error);
	}, 'json');
	return false;
}
function user_unignoreVideo(id) {
	$.get('/people/' + id + '/?section=ajax_unignore', function(data) {
		if (data.success) {
			if ($('#user-' + id).length) $('#user-' + id).fadeOut('fast', function () { $(this).remove(); });
			alert("Peace!!!");
		} else alert(data.error);
	}, 'json');
	return false;
}

//--------------------------------------------------------------------------------------------------

function people_Search(field) {
	var q = $(field).val();
	if (!q || q.length < 3) {
		$('#block-results').remove();
		$('#block-main').show();
		return;
	}

	$.post('/people?mode=search', {query : q}, function(data) {
		$('#block-results').remove();
		$('#block-main').hide().after(data);
	});
}

/*--------------------------------------------------------------------------------------------------
	Video
--------------------------------------------------------------------------------------------------*/

function video_checkProcessing(vik, ajax) {
	var vik_timer = 0;
	var new_state = function() {
		var video_state = $('#video-state-' + vik);
		if (!video_state.length && vik_timer) {
			clearInterval(vik_timer);
			vik_timer = 0;
		}

		$.getJSON('/video/' + vik + '/?section=ajax_state', function(data) {
		switch(data.state) {
			case 0:
			case 10:
			case 11:
				video_state.html(!data.position ? 'Видео ожидает обработки' : 'Позиция видео в очереди на обработку: ' + data.position); break;
			case 3: video_state.html('Видео почти обработалось'); break;
			case 4:
				video_state.html('Видео на предмодерации');
				if (vik_timer) {
					clearInterval(vik_timer);
					vik_timer = 0;
				}
				break;
			case 1: video_state.html('Видео обрабатывается' + (data.percent ? ': ' + data.percent + '%' : '...')); break;
			case -1:
			case 2:
				if (vik_timer) {
					clearInterval(vik_timer);
					vik_timer = 0;
				}
				if (typeof (ajax) == 'undefined') window.location.reload();
				else $.get('/video/' + vik + '/?section=ajax_item', function(data) {video_state.parent().html(data);});
				break;
		}
	})};

	vik_timer = setInterval(new_state, 5000);
}

function video_fave(key, action) {
	var fave = $('#video-fave-count');
	$.get('/video/' + key + '/?' + action, function(data) {$('#video_Fave').replaceWith(data);});
	fave.html(parseInt(fave.html()) + (action == 'fave' ? 1 : -1));
	return false;
}

function channel_fave(channel, action) {
	$.get('/' + Static.module + '/' + channel + '/?section=' + action, function(data) {$('#channel_Fave').replaceWith(data);});
	return false;
}

function video_toggleWide() {
	if ($('#video-container').hasClass('vc')) {
		$('#video-container').removeClass('vc').addClass('vc-wide');

		cookie_set('video-wide', 1);
	} else {
		$('#video-container').removeClass('vc-wide').addClass('vc');
		cookie_set('video-wide', 0);
	}
	player_ratio();

	return false;
}


function video_updatePosition(video_id, time) {
	Static.sock.send({action: 'video_uP', video_id: video_id, time: time});
}

function video_updatePositionEnd(video_id) {
	Static.sock.send({action: 'video_uPE', video_id: video_id});
}

function video_showStats(key) {
	if ($('#video-stats').is(':visible')) { $('#video-stats').slideUp(); return false; }
	$.get('/video/' + key + '/?stats', function(data) {
		$('#video-stats').hide().html(data).slideDown();
	});
	return false;
}

function video_UpdateConvertingGallery(user_id) {
	var interval = setInterval(function() {
		var vgc = $('#video-gallery-converting');
		if(!vgc.length) {clearInterval(interval); return;}
		$.get('/people/' + user_id + '/?section=video-converting&ajax', function(data) {
			vgc.hide().html(data).fadeIn('fast');
		});
	}, 10000);
	return false;
}

/*--------------------------------------------------------------------------------------------------
	Channels
--------------------------------------------------------------------------------------------------*/

function channel_addTeam(channel, id, name) {
	if (id == 0) {
		$('#static-content').dialog({
			title: 'Добавить человека в команду',
			fields: {
				'url': ['text','ID или ссылка на страницу', '']
			},
			buttons: {
				'add_by_url': ['submit','Добавить'],
				'cancel': ['cancel','Отмена']
			},
			text: "Когда человек в команде, он может добавлять и организовывать видео на канале.",
			action: '/' + Static.module + '/' + channel + '/?section=ajax_team_add',
			method: 'post',
			ajax: true,
			onSuccess: function() {redirect();}
		});
	} else {
		$('#static-content').dialog({
			title: 'Добавить человека в команду',
			fields: {
			},
			buttons: {
				'add_by_id': ['submit','Добавить'],
				'cancel': ['cancel','Отмена']
			},
			text: "Вы точно хотите добавить в команду <a href='/people/" + id + "'>" + name + "</a>?",
			action: '/' + Static.module + '/' + channel + '/?section=ajax_team_add&user_id=' + id,
			method: 'post',
			ajax: true,
			onSuccess: function() {redirect();}
		});
	}

	return false;
}

function channel_removeTeam(channel, id) {
	if (!confirm('Удалить из команды?')) return false;
	$.ajax('/' + Static.module + '/' + channel + '/?section=ajax_team_remove&user_id=' + id);
	$('#user-' + id).fadeOut('fast', function() {$(this).remove();});
	return false;
}

function channel_resetView(channel) {
	if (!confirm('Уверены что хотите сбросить прогресс просмотра всех серий в сериале?')) return false;
	$.ajax('/' + Static.module + '/' + channel + '/?section=reset_view').done(function() {redirect();});
	return false;
}

function channel_Follow(channel, a) {
	$.ajax('/' + Static.module + '/' + channel + '/?section=ajax_follow');
	$(a).replaceWith("<a href='#' onClick=\"return channel_Unfollow('" + channel + "', this);\"><i class='i-cancel'></i>Отписаться</a>");
	$('#count-follower').html(parseInt($('#count-follower').html()) + 1);
	$('#channel-notify').removeClass('invisible');
	return false;
}

function channel_Unfollow(channel, a) {
	if (!confirm('Вы точно хотите отписаться от канала?')) return false;
	$('#channel-notify').addClass('invisible');
	$.ajax('/' + Static.module + '/' + channel + '/?section=ajax_unfollow');
	$(a).replaceWith("<a href='#' onClick=\"return channel_Follow('" + channel + "', this);\"><i class='i-link'></i>Подписаться на обновления</a>");
	$('#count-follower').html(parseInt($('#count-follower').html()) - 1);
	return false;
}

function channel_FollowEmail(channel, follow, a) {
	$.ajax('/' + Static.module + '/' + channel + '/?section=ajax_follow_email&follow=' + follow).done(function(data) {
		if (data == "ok") $(a).replaceWith("<a href='#' id='channel-follow-email' onClick=\"return channel_FollowEmail('" + channel + "', " + (1 - follow) + ", this);\"><i class='i-" + (follow ? "ok" : "cancel") + "'></i>Уведомления по почте</a>");
	});
	return false;
}

function channel_FollowSMS(channel, follow, a, check) {
	if (follow && check && !confirm('Вы уверены? За каждую SMS с вас будет снято 1 рубль. При отсутствии денег на счету уведомления не будут отправляться.')) return false;
	$.ajax('/' + Static.module + '/' + channel + '/?section=ajax_follow_sms&follow=' + follow).done(function(data) {
		if (data == "ok") $(a).replaceWith("<a href='#' id='channel-follow-sms' onClick=\"return channel_FollowSMS('" + channel + "', " + (1 - follow) + ", this);\"><i class='i-" + (follow ? "ok" : "cancel") + "'></i>Уведомления по SMS</a>");
		if (data == "no phone") {
			$('#static-content').dialog({
				title: 'Телефон',
				fields: {
					'phone': ['text', 'Телефон', '', 'phone']
				},
				buttons: {
					'add': ['submit', 'Добавить'],
					'cancel': ['cancel', 'Отмена']
				},
				action: '/people/' + Static.user.id + '?section=ajax_set_phone',
				method: 'post',
				ajax: true,
				onSuccess: function(data) {
					channel_FollowSMS(channel, follow, a, false);
				}
			});
			$(".phone").mask("(999) 999-9999");
		}
	});

	return false;
}

//--------------------------------------------------------------------------------------------------

function channel_categoryAdd(channel, mode) {
	channel_categoryForm(channel, mode, 0, {});
	return false;
}
function channel_categoryEdit(channel, mode, category) {
	$.getJSON('/' + Static.module + '/' + channel + '/?section=ajax_category_get&category_id=' + category, function(cat) {
		channel_categoryForm(channel, mode, category, cat);
	});
	return false;
}

function channel_categoryForm(channel, mode, category, cat) {
	var fields = {
		'title': ['text', 'Название категории', cat.title],
		'description': ['textarea', 'Описание', cat.description]
	};
	if (mode == 'series') {
		fields['season'] = ['text', 'Номер сезона', cat.season];
		fields['season_name'] = ['text', 'Номер сезона для видео', cat.season_name];
		fields['count_video_total'] = ['text', 'Всего серий', cat.count_video_total];
		fields['year'] = ['text', 'Год', cat.year];
	}

	$('#static-content').dialog({
		title: category ? 'Редактировать категорию' : 'Добавить категорию',
		fields: fields,
		buttons: {
			'add': ['submit', 'Сохранить'],
			'cancel': ['cancel', 'Отмена']
		},
		action: '/' + Static.module + '/' + channel + '/?section=ajax_category_edit&category=' + category,
		method: 'post',
		ajax: true,
		onSuccess: function (data) {
			if (category) {
				$('#c-' + category + ' a').html(data.title);
				$('#category-description').html(data.processed);
			} else {
				var $new = $("<li><a href='/" + Static.module + "/" + channel + "/?section=video&category=" + data.id + "'>" + data.title + "</a></li>");
				if ($('#c-0').length) $new.insertBefore('#c-0'); else $('#channel-category-line').append($new);
				Static.channel.categories[data.id] = data.title;
			}
		}
	});
}

function channel_categoryDelete(channel, category) {
	$('#static-content').dialog({
		title: 'Удалить категорию',
		fields: {'with_video': ['checkbox', 'С видео']},
		text: 'Видео удалено не будет, его можно будет потом найти в «Без категории».',
		buttons: {
			'delete': ['submit','Удалить категорию'],
			'cancel': ['cancel','Отмена']
		},
		action: '/' + Static.module + '/' + channel + '/?section=ajax_category_delete&category=' + category,
		method: 'post',
		ajax: true,
		onSuccess: function(data) {
			$('#c-' + category).remove();
			delete Static.channel.categories[category];
		}
	});

	return false;
}

//--------------------------------------------------------------------------------------------------

function channel_videoAdd(channel, section, category_id) {
	var fields = {
		'url': ['text', 'Ссылка на видео']
	};

	if (section != "movie") fields["category"] = ['select', 'Категория', !category_id ? 0 : category_id, Static.channel.categories];
	else fields["type"] = ['select', 'Тип', 0, { "Фильм": "Фильм", "Трейлер": "Трейлер", "Сопутствующие материалы": "Сопутствующие материалы" }];

	$('#static-content').dialog({
		title: 'Добавить видео',
		text: "<a href='/video/upload'>Загрузите</a> видео или добавьте уже загруженное.",
		fields: fields,
		buttons: {
			'add': ['submit','Добавить'],
			'cancel': ['cancel','Отмена']
		},
		action: '/' + section + '/' + channel + '/?section=ajax_video_add',
		method: 'post',
		ajax: true,
		onSuccess: function(data) {redirect();}
	});

	return false;
}

function set_channelAdd(channel_id) {
	$.getJSON('/ajax/set_list', {channel_id: channel_id}, function(sets) {
		sets[0] = "Добавить новый";
		$('#static-content').dialog({
			title: 'Добавить в подборку',
			fields: {
				'set_id': ['select', 'Подборка', 0, sets],
				'name': ['text_placeholder', 'Название подборки', '']
			},
			buttons: {
				'add': ['submit','Добавить'],
				'cancel': ['cancel','Отмена']
			},
			action: '/ajax/set_add?channel_id=' + channel_id,
			method: 'post',
			ajax: true,
			onSuccess: function() {redirect();}
		});

		$("#dialog-content-top #field-set_id").on('change', function() {
			var val = $(this).val();
			if(val > 0) $("#dialog-content-top #field-name").hide();
			else $("#dialog-content-top #field-name").show();
		});
	});

	return false;
}

function set_channelEdit(set_id) {
	$('#static-content').dialog({
		title: 'Редактирование подборки',
		fields: {
			'name': ['text_placeholder', 'Название подборки', $('#name').text()],
			'description': ['textarea', 'Описание', $('#description').text()],
			'delete': ['checkbox', 'Удалить']
		},
		buttons: {
			'add': ['submit','Сохранить'],
			'cancel': ['cancel','Отмена']
		},
		action: '/set/' + set_id + '?ajax=edit',
		method: 'post',
		ajax: true,
		onSuccess: function() {redirect();}
	});

	return false;
}

//--------------------------------------------------------------------------------------------------

function channel_organizeExec(el, channel, category, new_category) {
	var video_id = el.id.split('-')[1];
	console.log([el, channel, category, new_category, video_id]);

	if (!new_category) {
		$.getJSON('/' + Static.module + '/' + channel + '/?section=ajax_video_remove&video=' + video_id + '&from=' + category, function(data) {
			if (data.success) {
				$(el).remove();
			} else if (data.error) {
				alert(data.error);
			} else { alert('Что-то пошло не так. Попробуйте позже.'); }
		});
	} else {
		$.getJSON('/' + Static.module + '/' + channel + '/?section=ajax_video_move&video=' + video_id + '&from=' + category + '&to=' + new_category, function(data) {
			if (data.success) {
				//redirect();
				$(el).remove();
			} else if (data.error) {
				alert(data.error);
			} else {alert('Что-то пошло не так. Попробуйте позже.');}
		});
	}
}

function channel_initOrganize(channel, category, section) {
	var items = [];
	items.push({title: 'Перенести в:'});
	$('#channel-category-line li[class!=inactive][class!=selected][class!=invisible]').each(function() {
		var id = this.id.split('-')[1], title = $(this).find('a').text();
		items.push({render: function() {return title;}, click: function(el) {
			channel_organizeExec(el, channel, category, id);
		}});
	});
	if (section == 'channel') {
		items.push({isSeparator: true});
		items.push({render: function() {return 'Удалить из канала';}, click: function(el) {
			channel_organizeExec(el, channel, category, 0);
		}});
	}

	if (items.length) {
		if (Static.video_context) {
			items.unshift({isSeparator: true});
			Static.video_context.addItems(items);
		} else Static.video_context = new context($(".video-gallery li"), {items});
		//Static.video_context.buttonEnable();
	}
}
//--------------------------------------------------------------------------------------------------

function video_initPlaylist() {
	if (Static.initPlaylist) return;
	Static.initPlaylist = true;
	var items = [{render: function() {return "Добавить в плейлист";}, click: function(el) {
		playlist_renderList(Static.video_context.getContextMenu(), el.id.split('-')[1]);
	}}];

	if (Static.video_context) {
		items.unshift({isSeparator: true});
		Static.video_context.addItems(items);
	} else Static.video_context = new context($(".video-gallery li"), {items});
}

//--------------------------------------------------------------------------------------------------

function series_showNew(address, channel_id, last_video_id) {
	var $v = $('#video-new-' + channel_id);
	if($v.is(':visible')) { $v.hide(); return false;}

	$v.show();

	if($('#video-series-' + channel_id).html() == '') {
		$v.find('td:first').html("<img src='/resource/image/icon/ajax.gif'>");
		$.get('/series/' + address + '/?section=ajax_video_from&id=' + last_video_id, function(data) {
			$('#video-series-' + channel_id).html(data);
			$v.find('td:first').html('');
		});
	}

	return false;
}

//--------------------------------------------------------------------------------------------------


function block_Toggle(id) {
	$('#block-' + id).slideToggle('fast', function() {
		cookie_set('block-' + id, $(this).is(':visible') ? 1 : 0);
	});
	return false;
}

function search_result(show) {
	if(show) {
		$('#video-index').hide();
		$('#video-index-right').hide();
		$('#video-search-no').hide();
	} else {
		$('#video-search-results').hide();
		$('#video-search-results-2').hide();
		$('#video-index').show();
		$('#video-index-right').show();
		$('#video-search-no').hide();
	}
	return false;
}

function search(event) {
	if(Static.search.counter != -1) clearTimeout(Static.search.counter);
	if(Static.search.query) Static.search.query.abort();

	if(event && event.keyCode == 27) {$('#search').val('');}
	Static.search.text = $('#search').val();
	if(Static.search.text == undefined) return false;

	var length_limit = Static.search.length_limit;
	if(event && event.keyCode == 13) length_limit = 2;
	if(Static.search.text.length < length_limit) { search_End(); return false; }

	Static.search.counter = setTimeout(search_Process, 300);
}

function search_Change() {
	var hash = document.location.hash.match(/#search\/(.+?)\/(.+)/);
	if(!hash) {$('#search').val(''); search();}

	if(hash && hash[1] && $('#search').val() != hash[2]) {
		Static.search.section = hash[1];
		$('#search').val(decodeURIComponent(hash[2]));
		search(0);
		return true;
	}
	return vector_search_Change();
}

function search_Re(query) {
	$('#search').val(query);
	search();
	return false;
}

function search_Init(section, length_limit) {
	if(section) Static.search.section = section;
	Static.search.length_limit = length_limit;

	search_Change();
	window.addEventListener("popstate", function(e) {
		if(search_Change()) e.preventDefault();
	}, false);

	var input = $('#search');
	input.keyup(search);
	input.on('paste', function() {setTimeout(search, 100);});
	if(!('ontouchstart' in window)) input.focus();
	$('#search-form form').submit(function() {
		return false;
	});

	if(Static.mobile) {
		var form = $("#search-form"), menu = $("#menu-search");
		menu.show();
		form.detach().appendTo("#menu-search").hide();
		if(input.val()) {
			form.show();
			menu.css("width", "250px");
		}
		menu.click(function(e) {
			if(e.target.nodeName == "INPUT") return false;
			if (form.is(":visible")) {
				search_End(); form.hide(); menu.css("width", "40px");
			} else {
				var vectorForm = $("#vector-search-form");

				if (vectorForm.is(":visible")) {
					vector_search_End();
					vectorForm.hide();
					$("#vector-menu-search").css("width", "40px");
				}

				form.show();
				menu.css("width", "250px");
				input.focus();
			}
		});
	}
}

function search_Process() {
	Static.search.query = $.post('/' + Static.search.section + '?mode=search&ajax', { 'query' : Static.search.text }, function(data) {
		if(!data) return false;
		search_Start();
		if(history != undefined) {
			let url = '#search/' + Static.search.section + '/' + Static.search.text;
			if (history.state != 'search') history.pushState('search', null, url);
			else history.replaceState('search', null, url);
		}

		var $container = Static.search.table.find('td.left');
		$('#search-additional').hide();

		switch (Static.search.section) {
			case 'video':
				$container.html(data);
				if (data.indexOf("id='kino-l'") != -1) {
					$('#search-additional').html('<div class="block-center-pale"><b><a href="#" onclick="$(window).scrollTo($(\'#kino-l\'), 500); return !1;">Найдены сериалы / фильмы</a></b></div>').show();
				}

				break;
			case 'audio':
				try { data = JSON.parse(data); } catch(e) {}
				$container.html('<div id="block-main" class="block"><h1 class="block-title">Музыка</h1><div id="block-main-content" class="block-content"><ul id="audio-search" class="audio-list"></ul></div></div>');
				if(typeof(audio_renderList) != 'function') nbl.l('/resource/js/audio.js', function() {audio_renderList(data);});
				else audio_renderList(data);
				break;
			case 'radio':
				try { data = JSON.parse(data); } catch(e) {}
				$container.html('<div id="block-main" class="block"><h1 class="block-title">Радио</h1><div id="block-main-content" class="block-content"><ul id="radio-search" class="radio-list"></ul></div></div>');
				radio_renderList(data);
				break;
			case 'kino':
			case 'series':
			case 'movie':
			case 'anime':
				$container.html(data);
				if (data.indexOf("id='person-l'") != -1) {
					$('#search-additional').html('<div class="block-center-pale"><b><a href="#" onclick="$(window).scrollTo($(\'#person-l\'), 500); return !1;">Найдены люди</a></b></div>').show();
				}
				break;
			default:
				$container.html(data);
				break;
		}

		//$.get('/ajax.php?mode=search_view&section=' + Static.search.section);
	});
}

function search_Start() {
	if(Static.search.started) return false;

	Static.search.mode = '';

	Static.search.table = $("<table id='content-table' class='main'><tr><td class='left'></td><td class='middle'></td><td class='right'></td></table>");
	Static.search.table.insertAfter($('#content-table'));

	$('#content-table').hide();

	Static.search.form = $('#search-form');

	var sections = [['video', 'Видео'], ['channel', 'Каналы'], ['kino', 'Сериалы и фильмы'], ['series', 'Только сериалы'], ['movie', 'Только фильмы'], ['anime', 'Только аниме'], ['audio', 'Аудио'],  ['radio', 'Радио'],  ['people', 'Пользователи'], ['set', 'Подборки'], ['person', 'Люди']];

	var $sections = "<ul class='thread-type-list'>";
	for(var i = 0; i < sections.length; i++) $sections += "<li><a style='background-image: url(/resource/image/module/" + sections[i][0] + ".png);background-size: 16px;' data-section='" + sections[i][0] + "' href='#'" + (Static.search.section == sections[i][0] ? "class='selected'" : '') + ">" + sections[i][1] + "</a></li>";
	$sections += "</ul>";

	$sections = $($sections);

	var section_check = function(val) {
		return val[0] == this;
	}

	$sections.find('a').click(function() {
		$sections.find('a.selected').removeClass('selected');
		$(this).addClass('selected');

		Static.search.section = $(this).data('section');
		if(!$sections.find(section_check, Static.search.section)) {
			console.error("wrong section");
			Static.search.section = '';
			return false;
		}
		search_Process();

		Static.search.form.find('input').focus();

		//$.get('/ajax.php?mode=search_init&section=' + Static.search.section);

		return false;
	});

	if(!Static.mobile) {
		Static.search.form.detach();
		Static.search.table.find('td.right').empty().prepend(Static.search.form).append($sections).append("<div id='search-additional'></div>");
		Static.search.form.find('input').focus();
	} else Static.search.table.find('td.right').empty().append($sections).append("<div id='search-additional'></div>");

	Static.search.started = true;

	//$.get('/ajax.php?mode=search_init&section=video');
}

function search_End() {
	if (!Static.search.started) return false;

	if (Static.search.mode === 'vector') {
		vector_search_End();
	} else {
		if (history != undefined) history.pushState(null, null, "#");

		if (!Static.mobile) Static.search.form.detach();
		else Static.search.form = "";

		Static.search.table.remove();
		$('#content-table').show();

		if (Static.search.form) {
			if ($('#content-table td.right').length) {
				$('#content-table td.right').prepend(Static.search.form);
			} else {
				$('#block-main-content').prepend(Static.search.form);
			}
			Static.search.form.find('input').focus();
		}

		Static.search.started = false;
	}
}

function vector_search_result(show) {
	if(show) {
		$('#video-index').hide();
		$('#video-index-right').hide();
		$('#video-search-no').hide();
	} else {
		$('#video-search-results').hide();
		$('#video-search-results-2').hide();
		$('#video-index').show();
		$('#video-index-right').show();
		$('#video-search-no').hide();
	}
	return false;
}

function vector_search(event) {
	if(Static.search.counter != -1) clearTimeout(Static.search.counter);
	if(Static.search.query) Static.search.query.abort();

	if(event && event.keyCode == 27) {$('#vector-search').val('');}
	Static.search.text = $('#vector-search').val();
	if(Static.search.text == undefined) return false;

	var length_limit = Static.search.length_limit;
	if(event && event.keyCode == 13) length_limit = 2;
	if(Static.search.text.length < length_limit) { vector_search_End(); return false; }

	Static.search.counter = setTimeout(vector_search_Process, 300);
}

function vector_search_Change() {
	var hash = document.location.hash.match(/#vector-search\/(.+?)\/(.+)/);
	if(!hash) {$('#vector-search').val(''); vector_search();}

	if(hash && hash[1] && $('#vector-search').val() != hash[2]) {
		Static.search.section = hash[1];
		$('#vector-search').val(decodeURIComponent(hash[2]));
		vector_search(0);
		return true;
	}
	return false;
}

function vector_search_Re(query) {
	$('#vector-search').val(query);
	vector_search();
	return false;
}

function vector_search_Init(section, length_limit) {
	//if(section) Static.search.section = section;
	//Static.search.length_limit = length_limit;

	//vector_search_Change();
	//window.addEventListener("popstate", function(e) {
	//	if(vector_search_Change()) e.preventDefault();
	//}, false);

	var input = $('#vector-search');
	input.keyup(vector_search);
	input.on('paste', function() {setTimeout(vector_search, 100);});
	//if(!('ontouchstart' in window)) input.focus();
	$('#vector-search-form form').submit(function() {
		return false;
	});

	if(Static.mobile) {
		var form = $("#vector-search-form"), menu = $("#vector-menu-search");
		menu.show();
		form.detach().appendTo("#vector-menu-search").hide();
		if(input.val()) {
			form.show();
			menu.css("width", "250px");
		}
		menu.click(function(e) {
			if(e.target.nodeName == "INPUT") return false;
			if (form.is(":visible")) {
				vector_search_End(); form.hide(); menu.css("width", "40px");
			} else {
				var oldForm = $("#search-form");

				if (oldForm.is(":visible")) {
					search_End();
					oldForm.hide();
					$("#menu-search").css("width", "40px");
				}

				form.show();
				menu.css("width", "250px");
				input.focus();
			}
		});
	}
}

function vector_search_Process() {
	Static.search.query = $.post('/' + Static.search.section + '?mode=vector-search&ajax', { 'query' : Static.search.text }, function(data) {
		if(!data) return false;
		vector_search_Start();
		if(history != undefined) {
			let url = '#vector-search/' + Static.search.section + '/' + Static.search.text;
			if (history.state != 'vector-search') history.pushState('vector-search', null, url);
			else history.replaceState('vector-search', null, url);
		}

		var $container = Static.search.table.find('td.left');
		$('#search-additional').hide();

		switch (Static.search.section) {
			case 'video':
				$container.html(data);
				if (data.indexOf("id='kino-l'") != -1) {
					$('#search-additional').html('<div class="block-center-pale"><b><a href="#" onclick="$(window).scrollTo($(\'#kino-l\'), 500); return !1;">Найдены сериалы / фильмы</a></b></div>').show();
				}

				break;
			case 'audio':
				try { data = JSON.parse(data); } catch(e) {}
				$container.html('<div id="block-main" class="block"><h1 class="block-title">Музыка</h1><div id="block-main-content" class="block-content"><ul id="audio-search" class="audio-list"></ul></div></div>');
				if(typeof(audio_renderList) != 'function') nbl.l('/resource/js/audio.js', function() {audio_renderList(data);});
				else audio_renderList(data);
				break;
			case 'radio':
				try { data = JSON.parse(data); } catch(e) {}
				$container.html('<div id="block-main" class="block"><h1 class="block-title">Радио</h1><div id="block-main-content" class="block-content"><ul id="radio-search" class="radio-list"></ul></div></div>');
				radio_renderList(data);
				break;
			case 'kino':
			case 'series':
			case 'movie':
			case 'anime':
				$container.html(data);
				if (data.indexOf("id='person-l'") != -1) {
					$('#search-additional').html('<div class="block-center-pale"><b><a href="#" onclick="$(window).scrollTo($(\'#person-l\'), 500); return !1;">Найдены люди</a></b></div>').show();
				}
				break;
			default:
				$container.html(data);
				break;
		}

		//$.get('/ajax.php?mode=search_view&section=' + Static.search.section);
	});
}

function vector_search_Start() {
	if(Static.search.started) return false;

	Static.search.mode = 'vector';

	Static.search.table = $("<table id='content-table' class='main'><tr><td class='left'></td><td class='middle'></td><td class='right'></td></table>");
	Static.search.table.insertAfter($('#content-table'));

	$('#content-table').hide();

	Static.search.form = $('#vector-search-form');

	var sections = [['series', 'Сериалы'], ['movie', 'Фильмы'], ['anime', 'Аниме']];

	var $sections = "<ul class='thread-type-list'>";
	for(var i = 0; i < sections.length; i++) $sections += "<li><a style='background-image: url(/resource/image/module/" + sections[i][0] + ".png);background-size: 16px;' data-section='" + sections[i][0] + "' href='#'" + (Static.search.section == sections[i][0] ? "class='selected'" : '') + ">" + sections[i][1] + "</a></li>";
	$sections += "</ul>";

	$sections = $($sections);

	var section_check = function(val) {
		return val[0] == this;
	}

	$sections.find('a').click(function() {
		$sections.find('a.selected').removeClass('selected');
		$(this).addClass('selected');

		Static.search.section = $(this).data('section');
		if(!$sections.find(section_check, Static.search.section)) {
			console.error("wrong section");
			Static.search.section = '';
			return false;
		}
		vector_search_Process();

		Static.search.form.find('input').focus();

		//$.get('/ajax.php?mode=search_init&section=' + Static.search.section);

		return false;
	});

	if(!Static.mobile) {
		Static.search.form.detach();
		Static.search.table.find('td.right').empty().prepend(Static.search.form).append($sections).append("<div id='search-additional'></div>");
		Static.search.form.find('input').focus();
	} else Static.search.table.find('td.right').empty().append($sections).append("<div id='search-additional'></div>");

	Static.search.started = true;

	//$.get('/ajax.php?mode=search_init&section=video');
}

function vector_search_End() {
	if (!Static.search.started) return false;
	if (history != undefined) history.pushState(null, null, "#");

	if (!Static.mobile) Static.search.form.detach();
	else Static.search.form = "";

	Static.search.table.remove();
	$('#content-table').show();

	if (Static.search.form) {
		if ($('#content-table td.right').length) {
			$('#content-table td.right #search-block').append(Static.search.form);
		} else {
			$('#block-main-content #search-block').append(Static.search.form);
		}
		Static.search.form.find('input').focus();
	}

	Static.search.started = false;
}

function channel_addr_by_title(section, create) {
	$("#channel_title").on('input', function() {$("#channel_address").val(transliterate($(this).val()));});
	if(create) {
		$(".channel_title").on('input', throttle(function() {
			var str = $(this).val();
			if(Static.search_string && Static.search_string == str) return;
			Static.search_string = str;
			if(str.length > 3) {
				if(section != "channel") {
					$.get('/' + section + '?mode=ajax_search&query=' + $(this).val(), function(data) {
						$("#movie_search").html(data);
					});
				}
				$.get('/' + section + '?mode=search&ajax&check_double&query=' + $(this).val(), function(data) {
					$("#duplicate_search").html(data);
				});
			}
		}, 700));
	}
	/*else {
		addr_get = function() {
			$("#channel_address").val(transliterate($("#channel_title_rus").val() + ($("#channel_title_original").val() ? '-' + $("#channel_title_original").val() : "")));
		};
		$("#channel_title_rus").keyup(addr_get);
		$("#channel_title_original").keyup(addr_get);
	}*/
}

function channel_import_kinopoisk(id) {
	$('#kinopoisk_id').val(id.split("-")[2]);
	$.getJSON("/channel", {mode: "ajax_import", site: "kinopoisk", id: id}, function(data) {
		$("#channel_title").val(data.name);
		$("#channel_title_original").val(data.original);

		$("#country").val(data.countries);
		$("#actors").val(data.actors);
		$("#director").val(data.directors);
		$("#field-post-text").val(data.descr);
		$("#year").val(data.year);
		$("#image").val(data.image);
		var list = [];
		$(data.genre.split(",")).each(function() {
			var genre = this.trim();
			if(genre == "мультфильм") genre = "Анимационный";
			if(genre == "для взрослых") genre = "Эротика";
			list.push(genre[0].toUpperCase() + genre.substring(1));
		});
		Static.genres.val(list).trigger("change");
		if(data.original) $("#channel_address").val(transliterate(data.original));
		$('#kinopoisk_id').val(data.id);
		$('#imdb_id').val(data.imdbId);
	});
	return false;
}

function channel_import_worldart(id) {
	$.getJSON("/channel", {mode: "ajax_import", site: "worldart", id: id}, function(data) {
		$("#channel_title").val(data.name);
		$("#channel_title_original").val(data.original);

		$("#country").val(data.countries);
		//$("#actors").val(data.actors);
		$("#director").val(data.directors);
		$("#field-post-text").val(data.descr);
		$("#year").val(data.year);
		$("#image").val(data.image);
		var list = [];
		$(data.genre.split(",")).each(function() {
			if(this.length) {
				var genre = this.trim();
				list.push(genre[0].toUpperCase() + genre.substring(1));
			}
		});
		Static.genres.val(list).trigger("change");
		$("#channel_address").val(transliterate(data.original));
	});
	return false;
}

function channel_import_tmdb(id) {
	$.getJSON("/channel", {mode: "ajax_import", site: "themoviedb", id: id}, function(data) {
		console.log(data);
		$("#channel_title").val(data.title);
		$("#channel_title_original").val(data.original_title);

		var countries = [], country;
		for(country in data.production_countries) {
			var name = data.production_countries[country].name;
			if(name == 'Russian') name = "Россия";
			else if(name == 'United States of America') name = "США";
			else if(name == 'Canada') name = "Канада";
			else if(name == 'France') name = "Франция";
			countries.push(name);
		}
		$("#country").val(countries.join(","));
		//$("#actors").val(data.actors);
		//$("#director").val(data.directors);
		$("#field-post-text").val(data.overview);
		$("#year").val(data.release_date.substr(0, 4));
		$("#image").val("https://image.tmdb.org/t/p/w600_and_h900_bestv2" + data.poster_path);
		var list = [], genre;
		for(genre in data.genres) {
			var name = data.genres[genre].name;
			name = name[0].toUpperCase() + name.slice(1);
			list.push(name);
		}
		Static.genres.val(list).trigger("change");
		$("#channel_address").val(transliterate(data.original_title));
		$('#date_release').val(data.release_date);
	});
	return false;
}

function tags2_init(type) {
	$(".tags2").select2({
		tags: true,
		minimumInputLength: type == 'genre' ? 1 : 3,
		tokenSeparators: [",", "#"],
		createSearchChoice: function(term, data) {
			if(type == 'genre') return null;

			if($(data).filter(function() {
				return this.text.localeCompare(term) === 0;
			}).length === 0) {
				return {id: term, text: term};
			}
		},
		multiple: true,
		ajax: {
			url: '/ajax/ajax_tags?type=' + type,
			dataType: "json",
			data: function(term, page) {
				return {q: term};
			},
			results: function(data0, page) {
				var data = [];
				$.each(data0, function(index, item) {item = item.trim(); data.push({id: item, text: item});});
				return {results: data};
			}
		},
		initSelection: function (element, callback) {
			var data = [];
			$(element.val().split(",")).each(function() {
				var text = this.trim();
				data.push({id: text, text: text});
			});
			callback(data);
		},
		tokenizer: function(input, selection, callback) {
			if((input.indexOf(',') < 0 && input.indexOf('#') < 0) || type == 'genre') return;

			var parts = input.split(/[,#]/);
			var i_max = parts.length;
			var j_max = selection.length;
			for(var i = 0; i < i_max; i++) {
				var part = parts[i];
				part = part.trim();
				for(var j = 0; j < j_max; j++) {
					if(selection[j].text.localeCompare(part) === 0) part = 0;
				}
				if(part) callback({id: part, text: part});
			}
		}
	});
}

function filter_tags_setup(object_id, el, placeholder, name) {
	el.select2({
		tags: true,
		placeholder: placeholder,
		minimumInputLength: 2,
		id: function(e) {return e.id + ":" + e.text;},
		tokenSeparators: [",", " "],
		multiple: true,
		ajax: {
			url: '/ajax.php?mode=ajax_tags2&id=' + object_id,
			dataType: "json",
			data: function(term, page) {
				return {q: term};
			},
			results: function(data, page) {
				return {results: data};
			}
		}
	}).change(function(e) {
		cookie_set(name + object_id, e.val.join(","), 3600);
		$(this).parents('form:first').submit();
	});

	var str = cookie_get(name + object_id);
	if (str) {
		let data = [];
		$(str.split(",")).each(function() {
			var item = this.split(':');
			data.push({
				id: item[0],
				text: item[1]
			});
		});
		el.select2('data', data);
	}
}

function filter_init(object_id) {
	filter_tags_setup(object_id, $("#filter"), 'Теги. Например: СССР', 'tags')
	filter_tags_setup(object_id, $("#filter-exclude"), 'Теги для исключения', 'tags_exclude')

	$("#genres").select2({
		placeholder: 'Жанры',
	}).change(function(e) {
		cookie_set("genres" + object_id, e.val.join(","), 3600);
		$(this).parents('form:first').submit();
	});

	$("#genres-exclude").select2({
		placeholder: 'Жанры для исключения',
	}).change(function(e) {
		cookie_set("genres_exclude" + object_id, e.val.join(","), 3600);
		$(this).parents('form:first').submit();
	});
}

function filter_exec(e) {
	function filter_reset() {
		$('#filter_reset').remove();
		if($('.left').find('#block-filter').length) $('#block-filter').insertBefore('#filter-spot');
		localStorage.removeItem('filter');
		return search_result(false);
	}
	if (e) Static.filter[$(this).attr('id')] = e.val;
	var filter = Static.filter;
	filter['order'] = $('#order').val();

	if (!filter['genre'].length && !filter['year'].length && !filter['country'].length && !filter['set'].length) return filter_reset();

	var filter_str = JSON.stringify(filter);
	$.get('/ajax/filter/?filter=' + filter_str, function(data) {
		if (!data) return false;
		else {
			localStorage.filter = filter_str;
			search_result(true);
		}

		$('#video-search-results').html(data);
		if (!$('#video-search-results').is(':visible')) $('#video-search-results').fadeIn('fast');

		if (Static.mobile && data && $('#content-sidebar').find('#block-filter').length) {
			$('#block-filter').insertBefore('#video-search-results');
		}

		if (!$('#filter-reset').length) {
			$('#order').after("<div id='filter-reset'><br><br><a href='#'>Сбросить фильтр</a></div>");
			$('#filter-reset a').click(function() {
				$("#genre").select2('val', '');
				$("#year").select2('val', '');
				$("#country").select2('val', '');
				$("#set").select2('val', '');
				$("#section").select2('val', '');
				Static.filter = {'genre': 0, 'year': 0, 'country': 0, 'set': 0, 'section': 0};
				return filter_reset();
			});
		}
	});
}

function filter_init_main() {
	const fields = {'genre': 'Жанр', 'year': 'Год', 'country': 'Страна', 'set': 'Подборка', 'section': 'Раздел'};
	for (let field in fields) {
		$("#" + field).select2({
			placeholder: fields[field],
		}).change(filter_exec);
		if(Static.filter[field]) $("#" + field).select2("val", Static.filter[field]);
	}
	$("#order").change(filter_exec);
	if(Static.filter.order) $("#order").val(Static.filter.order);
}
function filter_init_main0(total) {
	var on_click = function(id) {
		if (total) {
			var t = $('.tags0');
			if (t.hasClass('loaded')) {
				if (t.hasClass('display')) {
					t.removeClass('display');
					t.html('Фильтровать');
					$('#tags0').hide();
				} else {
					t.addClass('display')
					t.html('Скрыть фильтр');
					$('#tags0').show();
				}
				return false;
			} else {
				console.log(t);
				t.addClass('loaded display')
				t.html('Скрыть фильтр');
			}
		}
		nbl.l(['/resource/js/select2.min.js', '/resource/select2.css'], function() {
			$.get('/ajax/tags0' + (total ? '?total=1' : ''), function(data) {
				$('#tags0').html(data);
				filter_init_main();
				if (id && !total) $("#" + id).select2('open');
				if (!id) filter_exec();
			});
		});
	}

	$('.tags0').click(function() {on_click(this.id);});

	var filter = localStorage.filter;
	Static.filter = filter ? JSON.parse(filter) : {'genre': 0, 'year': 0, 'country': 0, 'set': 0, 'section': 0};
	if (filter) on_click(false);
}

function filter_init_set(object_id, field) {
	var filter = localStorage.filter;
	filter = filter ? JSON.parse(filter) : {'genre': 0, 'year': 0, 'country': 0, 'set': 0, 'section': 0};
	filter[field] = [object_id];
	localStorage.filter = JSON.stringify(filter);
}

function main_on_rezise(parent, rows, max_row) {
	var status = parent.data("status");
	var ret = false;
	if (!rows && status != 'min') {
		parent.removeClass('max').addClass('min')
			.find(".minus").css('visibility', 'hidden');
		if (status == 'max') parent.find(".plus").css('visibility', 'visible');
		ret = true;
		status = 'min';
	} else if(rows == max_row && status != 'max') {
		parent.removeClass('min').addClass('max')
			.find(".plus").css('visibility', 'hidden');
		if (status == 'min') {
			parent.find(".minus").css('visibility', 'visible');
			ret = true;
		}
		status = 'max';
	} else if(rows && status == 'min') {
		parent.removeClass('min').find(".minus").css('visibility', 'visible');
		status = 'normal';
	} else if(rows < max_row && status == 'max') {
		parent.removeClass('max').find(".plus").css('visibility', 'visible');
		status = 'normal';
	} else return ret;

	parent.data("status", status);
	return ret;
}

function main_block_resize(e, minus) {
	var parent = e.parent().parent().parent(),
		block = parent.find(".block-content"),
		id = parent.attr("id"),
		rows = block.data("rows"),
		max_row = block.data("max_row");

	rows += minus ? -1 : 1;
	if (rows < 0) rows = 0;
	else if(rows > max_row) rows = max_row;

	for (var i = 0; i < max_row; i++) {
		var item = $("#" + id + ' .row-' + i);
		if (i == rows - 1 && !minus && !item.length) {
			$.get('/ajax/main-row', {type: id, num: rows, items_in_row: Static.items_in_row}, function(data) {
				block.find('ul').append(data);
				$("#" + id + ' .row-' + (rows - 1)).hide().slideDown();
				if (!data) block.data("max_row", rows);
			});
		}
		if (i >= rows) item.slideUp(); else item.slideDown();
	}

	block.data("rows", rows);
	cookie_set("row." + id, rows);

	main_on_rezise(parent, rows, max_row);
}

function main_init_rows(max_row) {
	$("#video-index .block").each(function() {
		var parent = $(this),
			block = parent.find(".block-content"),
			id = parent.attr("id"),
			rows = parseInt(cookie_get("row." + id));
		if (isNaN(rows)) {
			rows = parseInt(parent.find(".default").text());
			if(isNaN(rows)) rows = 1;
		}
		for (var i = rows; i < max_row; i++) {
			var item = $("#" + id + ' .row-' + i);
			//if(!item.length && i) {max_row = i; break;}
			item.hide();
		}

		block.data("rows", rows);
		block.data("max_row", max_row);
		main_on_rezise(parent, rows, max_row);
	});
}

function main_Init() {
	if (!$(".minus").length) {
		$("#video-index .block-title").each(function() {
			$(this).append("<span class='right expander'><a href='#' class='minus'></a> <a href='#' class='plus'></a></span>");
		});

		$(".minus").click(function() {main_block_resize($(this), true); return false;});
		$(".plus").click(function() {main_block_resize($(this), false); return false;});
	}

	var resize_rows = function(mql) {
		var items_in_row = mql.matches ? 1 : 2;
		Static.items_in_row = items_in_row;
		$("#video-index .block").each(function() {
			var parent = $(this), i = 0;
			parent.find("li").each(function() {
				var item = $(this), cl = item.attr('class');
				item.removeClass(cl).addClass('row-' + (items_in_row == 1 ? i : Math.floor(i / items_in_row))).show();
				++i;
			});
		});
		main_init_rows(9);
	};

	Static.items_in_row = 3;
	if (typeof window.matchMedia == 'function') {
		var mql = window.matchMedia("(max-width: 900px)");
		if (mql.matches) {
			mql = window.matchMedia("(max-width: 560px)");
			mql.addListener(resize_rows);
			resize_rows(mql);
		} else main_init_rows(3);
	} else main_init_rows(3);
}

function video_tabs_Init() {
	$('.video_tabs input').click(function() {
		redirect(window.location.pathname + "?source=" + $(this).attr("name"));
	});
}

function review_editInit() {
	$('#field-text').keyup(function() {
		$('#text_len').text($('#field-text').val().length);
	});

	$('.rate').on('mouseover', function() {
		var par = $(this).attr('id').split("-");
		for(var i = 1; i < 6; i++) $('#rate-' + i).attr('src', '/resource/image/icon/star-small' + (i <= par[1] ? '' : '-empty') + '.png');
		$('#rate').val(par[1]);
	});

	$('#review-form').submit(function(e) {
		if($('#field-title').val().length < 3) {
			alert('Не введен заголовок');
			e.preventDefault();
		}
		if($('#field-text').val().length < 500) {
			alert('Рецензия должна быть не менее 500 символов');
			e.preventDefault();
		}
		if(!$('#rate').val) {
			alert('Не указана оценка');
			e.preventDefault();
		}
	});
}

function review_init() {
	$('.review').on({
		'mouseover': function() {$(this).find('.post-controls').show();},
		'mouseout': function() {$(this).find('.post-controls').hide();}
	});
}

function video_description(video_id) {
	if (!video_id) return false;
	player_deFocus();

	$('#static-content').dialog({
		title: 'Описание видео',
		text: "Опиши видео и получи VIP* на два дня.<br><br>* Для получения VIP необходимо, чтобы текст был не менее 300 символов и не скопирован из интернета.<br>Длина текста: <span id='text_len'>0</span>",
		fields: {
			'text': ['textarea','Текст']
		},
		buttons: {
			'save' : ['submit','Отправить на модерацию']
		},
		action: '/ajax/video_desc?video_id=' + video_id,
		method: 'post',
		ajax: true,

		onSuccess: function() {
			alert("Ваше описание в течении нескольких часов будет просмотрено и после одобрения вы получите VIP.");
		}
	});

	$('#field-text').keyup(function() {
		$('#text_len').text($(this).val().length);
	});

	return false;
}

function channel_note(channel) {
	player_deFocus();

	$('#static-content').dialog({
		title: 'Заметка к фильму',
		fields: {
			'text': ['textarea','Текст', $('#note .text').text()]
		},
		buttons: {
			'save' : ['submit','Сохранить']
		},
		action: '/' + Static.module + '/' + channel + '/?section=note&save',
		method: 'post',
		ajax: true,
		onSuccess: function () {console.log("test"); redirect(); }
	});

	return false;
}

function video_history(id) {
	$.get('/ajax/video_history?id=' + id, function(data) {
		$('#static-content').dialog({
			title: "История",
			text: data,
			width: Static.mobile ? 300 : 500
		});
	});
	return false;
}

function mark_del(video_id, time) {
	$.getJSON('/video/' + video_id + '/?section=del_mark&t=' + time, function() {
		redirect();
	});
	return false;
}

function mark_add(end, pos) {
	var types = {"0": "Таймкод", "b": "Начало"};
	if (end) types['e'] = "Конец";

	$('#static-content').dialog({
		title: "Добавить таймкод",
		fields: {
			'time': ['text', 'Время', pos ? pos : ''],
			'text': ['text', 'Комментарий', ''],
			'type': ['select', 'Тип', 0, types]
		},
		buttons: {
			'add': ['submit', 'Добавить'],
			'cancel': ['cancel', 'Отмена']
		},
		text: pos ? "Будет добавлен таймкод на текущий момент времени в плеере" : "",
		action: $('#video-flash').attr('href') + "?section=add_mark",
		method: 'post',
		ajax: true,
		onSuccess: function () { redirect(); }
	});

	return false;
}

function subtitles_add(video_id, mode) {
	$('#static-content').dialog({
		title: "Загрузить субтитры",
		fields: {
			'title': ['text', 'Заголовок', ''],
			'subtitle': ['file', '.srt,.ass,.ssa', '<small>Допустимы только *.srt, ass, ssa!</small>'],
			'hash': ['hidden', Static.user.session]
		},
		buttons: {
			'add': ['submit', 'Загрузить'],
			'cancel': ['cancel', 'Отмена']
		},
		action: "https://m.krasview.ru:8081/upload-misc?mode=" + mode + "&video_id=" + video_id,
		method: 'post',
		ajax: false,
		onSubmit: function () { $('#dialog-info').html("Загрузка субтитров началась. Другие пользователи смогут их увидеть только после модерации."); }
	});

	return false;
}

function video_ViewClear() {
	if (!confirm('Уверены?')) return false;
	$.getJSON('/ajax/video_view_clear', function() {
		redirect();
	});
	return false;
}

function user_page() {
	$('#info').mouseleave(function() { $('#extended-info').slideUp('fast'); });
	if (Static.mobile) {
		$("#user-avatar-container").hide();
		$("#user-avatar-info").insertAfter("#user-avatar-container");
		$("#user-info").css("margin-left", 0);
	}
}